import { useProjectSuspenseQuery } from "@/api/queries/projects/useProjectSuspenseQuery"
import ProjectDetail from "@/pages/contracten/contract_detail/ProjectDetail"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/organisaties/$organization",
)({
  component: OrganizationOverview,
  beforeLoad: () => {
    checkOrganizationPermissions("read", "projects")
  },
})

function OrganizationOverview() {
  const { contractId, organization } = useParams({
    from: "/beheer/contracten/$contractId/organisaties/$organization",
  })

  const { data: project } = useProjectSuspenseQuery({
    projectId: Number(contractId),
  })

  const organizations = project.organizations || []

  const activeOrganization = organizations.find(
    (c) => c.id === Number(organization) || c.name === organization,
  )

  return (
    <>
      {activeOrganization && <ProjectDetail />}

      {!activeOrganization && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">
            Selecteer een organisatie om de planning te bekijken
          </p>
        </div>
      )}
    </>
  )
}
